import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    cursor: 'pointer'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SwiftMenu/Basket/Icon/styles.js